/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@emotion/react';
import { N0 } from '@atlaskit/theme/colors';
import { BORDER_WIDTH } from './constants';
const iconWrapperStyles = css({
  display: 'flex',
  boxSizing: 'border-box',
  width: '100%',
  height: '100%',
  alignItems: 'center',
  alignContent: 'center',
  borderRadius: "var(--ds-border-radius-circle, 50%)",
  overflow: 'hidden'
});

/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */
const IconWrapper = ({
  bgColor = `var(--ds-surface-overlay, ${N0})`,
  children
}) => jsx("span", {
  css: iconWrapperStyles,
  role: "presentation",
  style: {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `${BORDER_WIDTH}px solid ${bgColor}`,
    backgroundColor: bgColor
  }
}, children);
export default IconWrapper;